import React, { useState } from "react";

const SeriesPreviewModal = ({ series, onClose }) => {
  const [previewMode, setPreviewMode] = useState("desktop");
  const baseUrl = window.location.origin;

  return (
    <div className="team-modal-overlay" onClick={onClose}>
      <div
        className="team-modal"
        style={{
          maxWidth: previewMode === "mobile" ? "480px" : "1200px",
          width: previewMode === "mobile" ? "90%" : "95vw",
          padding: 0,
          border: "none",
          borderRadius: "12px",
          boxShadow: "0 20px 40px rgba(0, 0, 0, 0.2)",
          transition: "max-width 0.2s ease"
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="team-modal-header" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <h3 className="team-modal-title" style={{ margin: 0 }}>Landing Page Preview</h3>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <div className="d-inline-flex rounded p-1" style={{ backgroundColor: "var(--sl-bg-tertiary)", gap: "4px" }}>
              <button
                type="button"
                className="btn btn-sm px-3 py-1 border-0"
                style={{
                  backgroundColor: previewMode === "desktop" ? "var(--sl-bg-primary)" : "transparent",
                  fontWeight: previewMode === "desktop" ? 600 : 400,
                  fontSize: "13px",
                  borderRadius: "6px",
                  boxShadow: previewMode === "desktop" ? "0 1px 2px rgba(0,0,0,0.05)" : "none",
                }}
                onClick={() => setPreviewMode("desktop")}
              >
                <i className="fas fa-desktop mr-1"></i> Desktop
              </button>
              <button
                type="button"
                className="btn btn-sm px-3 py-1 border-0"
                style={{
                  backgroundColor: previewMode === "mobile" ? "var(--sl-bg-primary)" : "transparent",
                  fontWeight: previewMode === "mobile" ? 600 : 400,
                  fontSize: "13px",
                  borderRadius: "6px",
                  boxShadow: previewMode === "mobile" ? "0 1px 2px rgba(0,0,0,0.05)" : "none",
                }}
                onClick={() => setPreviewMode("mobile")}
              >
                <i className="fas fa-mobile-alt mr-1"></i> Mobile
              </button>
            </div>
            <button className="team-modal-close" onClick={onClose} style={{ position: "static" }}>
              <i className="fa fa-times"></i>
            </button>
          </div>
        </div>
        <div className="team-modal-body" style={{ padding: "0 24px 24px", display: "flex", justifyContent: "center" }}>
          <iframe
            src={`${baseUrl}/s/${series.public_permalink}?layout=iframe&preview=true`}
            title={series.name || "Series"}
            style={{
              border: "none",
              width: previewMode === "mobile" ? "414px" : "100%",
              height: "80vh",
              minHeight: "600px",
              transition: "width 0.2s ease"
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default SeriesPreviewModal;
